import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstructivoEmbarqueRoutingModule } from './instructivo-embarque-routing.module';
import { WizardComponent } from './wizard/wizard.component';
import { Step1ViajeComponent } from './wizard/steps/step1-viaje/step1-viaje.component';
import { Step2BookingOrganizacionesComponent } from './wizard/steps/step2-booking-organizaciones/step2-booking-organizaciones.component';
import { Step3CargaFinancierosComponent } from './wizard/steps/step3-carga-financieros/step3-carga-financieros.component';
import { Step4RevisionComponent } from './wizard/steps/step4-revision/step4-revision.component';

@NgModule({
    imports: [
        CommonModule,
        InstructivoEmbarqueRoutingModule,
        WizardComponent,
        Step1ViajeComponent,
        Step2BookingOrganizacionesComponent,
        Step3CargaFinancierosComponent,
        Step4RevisionComponent,
    ],
})
export class InstructivoEmbarqueModule {}
